import {
  ISetSftpPartnerEnabledRequest,
  ISftpPartnerDetailResponse,
  ISftpPartnerListResponse,
} from "types/SftpPartner";

import { api } from ".";

// SFTP ingestion partners — SuperAdmin only (Integrations → SFTP).
const sftpPartnerQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getSftpPartners: builder.query<ISftpPartnerListResponse, void>({
      query: () => ({
        url: "/integration/sftp/partners",
        method: "GET",
      }),
      providesTags: [{ type: "SftpPartners", id: "LIST" }],
    }),
    getSftpPartner: builder.query<ISftpPartnerDetailResponse, string>({
      query: (slug) => ({
        url: `/integration/sftp/partners/${encodeURIComponent(slug)}`,
        method: "GET",
      }),
      providesTags: (_result, _error, slug) => [
        { type: "SftpPartners", id: slug },
      ],
    }),
    // The only write on the page: the server accepts `enabled` and nothing else.
    setSftpPartnerEnabled: builder.mutation<
      ISftpPartnerDetailResponse,
      ISetSftpPartnerEnabledRequest
    >({
      query: ({ slug, enabled }) => ({
        url: `/integration/sftp/partners/${encodeURIComponent(slug)}`,
        method: "PATCH",
        body: { enabled },
      }),
      invalidatesTags: (_result, _error, { slug }) => [
        { type: "SftpPartners", id: "LIST" },
        { type: "SftpPartners", id: slug },
      ],
    }),
  }),
});

export const {
  useGetSftpPartnersQuery,
  useGetSftpPartnerQuery,
  useSetSftpPartnerEnabledMutation,
} = sftpPartnerQueries;
